import { InjectionToken } from '@angular/core';
import { IConfigsRepository } from '../../domain/repository/configs.respository';

export const CONFIGS_OPTIONS_SYSTEM_CONFIGS =
  new InjectionToken<IConfigsRepository>('IConfigsRepository');
